module.exports = __webpack_public_path__ + "static/airsupply-logo-342d77240736402db388f79676cfc4b5.png";